class ImageBadges extends HTMLElement {
  connectedCallback() {
    this.gallery = this.closest("[data-gallery]");
    if (!this.gallery) return;

    this.container = this.gallery.querySelector("[data-swiper-container]");
    this.firstOnly = this.dataset.firstOnly === "true";
    this.lockSwipe = this.dataset.lockSwipe === "true";
    this.breakpoint = parseInt(this.dataset.lockBreakpoint || "900", 10);

    this.onReposition = () => this.positionToImage();
    window.addEventListener("resize", this.onReposition);
    window.addEventListener("load", this.onReposition);
    this.positionToImage();
    this.syncThumbs();
    window.setTimeout(this.onReposition, 300);
    window.setTimeout(this.onReposition, 1200);
    window.setTimeout(() => this.syncThumbs(), 400);
    window.setTimeout(() => this.syncThumbs(), 1200);

    if (this.container) {
      this.observer = new MutationObserver(() => {
        this.syncVisibility();
        this.positionToImage();
        this.syncThumbs();
      });
      this.observer.observe(this.container, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
      });
      this.syncVisibility();
    }

    if (this.lockSwipe) {
      this.onResize = () => this.applySwipeLock();
      window.addEventListener("resize", this.onResize);
    }

    this.waitForSwiper(0);

    this.onGalleryUpdate = () => {
      this.syncVisibility();
      this.positionToImage();
      this.syncThumbs();
      if (this.lockSwipe) this.applySwipeLock();
    };
    document.addEventListener("gallery:updated", this.onGalleryUpdate);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onReposition) {
      window.removeEventListener("resize", this.onReposition);
      window.removeEventListener("load", this.onReposition);
    }
    if (this.onResize) window.removeEventListener("resize", this.onResize);
    if (this.onGalleryUpdate) {
      document.removeEventListener("gallery:updated", this.onGalleryUpdate);
    }
    if (this.timer) window.clearTimeout(this.timer);
  }

  slides() {
    if (!this.container) return [];
    return Array.from(this.container.querySelectorAll("[data-swiper-slide]"));
  }

  positionToImage() {
    const slide = this.slides()[0];
    const image = slide ? slide.querySelector("img") : null;
    if (!image || !this.gallery) return;

    const box = this.gallery.getBoundingClientRect();
    const rect = image.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    this.style.top = Math.round(rect.top - box.top) + "px";
    this.style.left = Math.round(rect.left - box.left) + "px";
    this.style.width = Math.round(rect.width) + "px";
    this.style.height = Math.round(rect.height) + "px";
    this.style.right = "auto";
    this.style.bottom = "auto";
  }

  syncThumbs() {
    const section = this.closest("gallery-section") || document;
    const thumbs = section.querySelector("[data-thumbs]");
    if (!thumbs) return;

    const items = Array.from(thumbs.querySelectorAll("[data-swiper-slide]"));
    if (!items.length) return;

    const swiper = this.gallery ? this.gallery.swiper : null;
    let index = 0;
    if (swiper && typeof swiper.realIndex === "number") {
      index = swiper.realIndex;
    } else if (swiper && typeof swiper.activeIndex === "number") {
      index = swiper.activeIndex;
    }

    items.forEach((item, i) => {
      item.classList.toggle("wt-thumb-active", i === index);
    });
  }

  syncVisibility() {
    if (!this.firstOnly) {
      this.hidden = false;
      return;
    }

    const slides = this.slides();
    if (slides.length < 2) {
      this.hidden = false;
      return;
    }

    const swiper = this.gallery ? this.gallery.swiper : null;
    let index = -1;

    if (swiper && typeof swiper.realIndex === "number") {
      index = swiper.realIndex;
    } else if (swiper && typeof swiper.activeIndex === "number") {
      index = swiper.activeIndex;
    } else {
      index = slides.findIndex((slide) => slide.classList.contains("swiper-slide-active"));
    }

    this.hidden = index > 0;
  }

  waitForSwiper(attempt) {
    if (attempt > 60) return;

    const swiper = this.gallery ? this.gallery.swiper : null;
    if (swiper) {
      if (this.lockSwipe) this.applySwipeLock();
      if (!this.swiperBound) {
        this.swiperBound = true;
        const update = () => {
          this.syncVisibility();
          this.positionToImage();
          this.syncThumbs();
        };
        swiper.on("slideChange", update);
        swiper.on("slideChangeTransitionEnd", update);
        swiper.on("transitionEnd", update);
        swiper.on("resize", () => this.positionToImage());
        update();
      }
      return;
    }
    this.timer = window.setTimeout(() => this.waitForSwiper(attempt + 1), 150);
  }

  applySwipeLock() {
    const swiper = this.gallery ? this.gallery.swiper : null;
    if (!swiper) return;

    const locked = window.innerWidth < this.breakpoint;
    swiper.allowTouchMove = !locked;
    if (typeof swiper.allowSlideNext === "boolean") {
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
    }
    this.gallery.classList.toggle("wt-ib-swipe-locked", locked);
  }
}

if (!customElements.get("image-badges")) {
  customElements.define("image-badges", ImageBadges);
}
